document.addEventListener('DOMContentLoaded', () => {
  // Ne s'exécute que sur la version française du site
  if (!document.documentElement.lang.toLowerCase().startsWith('fr')) {
    return;
  }

  const dateRegex =
    /(janv\.|févr\.|mars|avr\.|mai|juin|juil\.|août|sept\.|oct\.|nov\.|déc\.)\s+(\d{1,2})/gi;

  function formatDeliveryDates() {
    const widgets = document.querySelectorAll(
      '.essential-estimated-delivery-widget'
    );

    widgets.forEach((widget) => {
      const walker = document.createTreeWalker(
        widget,
        NodeFilter.SHOW_TEXT
      );

      let node;

      while ((node = walker.nextNode())) {
        const text = node.nodeValue;

        if (!text) continue;

        const formatted = text.replace(
          dateRegex,
          '$2 $1'
        );

        if (formatted !== text) {
          node.nodeValue = formatted;
        }
      }
    });
  }

  // Premier passage
  formatDeliveryDates();

  // Essential Estimated peut charger ou recalculer le widget après la page
  const observer = new MutationObserver(() => {
    formatDeliveryDates();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true
  });
});